const POLL_INTERVALS_MS = [1000, 1000, 2000, 3000, 5000, 8000, 13000, 20000, 30000];

export const parseProcessingPageLocation = () => {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const processingIndex = pathParts.indexOf('processing');
    const paymentRequestId = processingIndex > 0 ? pathParts[processingIndex - 1] : pathParts[0];
    return { paymentRequestId };
};

export const pollPaymentStatus = async ({ lyriaUrl, paymentRequestId, axios }) => {
    const response = await axios({
        method: 'post',
        url: `${lyriaUrl}/paymentStatus/${paymentRequestId}`,
    });
    return response.data;
};

export const startPaymentStatusPolling = ({ lyriaUrl, paymentRequestId, axios, onUpdate, onError }) => {
    let intervalIndex = 0;
    let timeoutId = null;
    let stopped = false;

    const scheduleNext = () => {
        if (stopped) {
            return;
        }
        const intervalMs = POLL_INTERVALS_MS[Math.min(intervalIndex, POLL_INTERVALS_MS.length - 1)];
        intervalIndex += 1;
        timeoutId = window.setTimeout(runPoll, intervalMs);
    };

    const runPoll = async () => {
        try {
            const data = await pollPaymentStatus({ lyriaUrl, paymentRequestId, axios });
            onUpdate(data);
            if (data.code === 'payment_being_processed') {
                scheduleNext();
            }
        } catch (error) {
            onError(error);
            scheduleNext();
        }
    };

    runPoll();

    return () => {
        stopped = true;
        if (timeoutId) {
            window.clearTimeout(timeoutId);
        }
    };
};
